import { Box, Drawer, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'
import { DinamicForm } from '../../../../../../../components/dinamicForm'
import { ObjectGeneric, onChangeEvent } from '../../../../../../../utils/types/generals'
import { InputModel } from '../../../../../../../utils/types'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { LoadingButton } from '@mui/lab'
import { sharedAws } from '../../../../../../../service/bucketS3/Storage'
import { generalDisabled } from '../../../../../../../utils/validate/validate'


export const ConverDestination = ({
    open,
    inputValues,
    getCityByID,
    getCompanyById,
    fatherList,
    childZones,
    setInputValues,
    closeDrawer,
    selectedPoint,
    value,
    handleConvert,
    loader
}: {
    open: boolean,
    inputValues: { [x: string]: InputModel; },
    getCityByID: (id?: number | undefined) => Promise<boolean>,
    getCompanyById: (id?: number | null | undefined, fatherZone?: number | undefined) => Promise<void>,
    fatherList: any[],
    childZones: any[],
    setInputValues: Dispatch<SetStateAction<{
        [x: string]: InputModel;
    }>>,
    closeDrawer: () => void,
    value: {
        name: string;
        direction: string;
        company?: {
            label: string;
            value: number;
        } | undefined;
    },
    selectedPoint: {
        lat: number;
        lng: number;
    } | null,
    handleConvert: (body: ObjectGeneric) => Promise<void>,
    loader: boolean
}) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const [data, setData] = useState<ObjectGeneric>({
        address: value.direction,
        companyId: value.company?.value,
        latitude: selectedPoint?.lat,
        longitude: selectedPoint?.lng,
        name: value.name,
        timeZone: "America/Guatemala"
    })

    const crudChange = async (e: onChangeEvent | string): Promise<void> => {
        if (typeof e !== 'string') {
            const { name, value } = e?.target

            let body = {
                ...data,
                [name]: name === 'score' && value === '-' ? '0' : value?.value ?? value,
            }

            if (name === 'states') {
                const responseCitites = await getCityByID(value?.value)
                if (responseCitites) {
                    body = { ...body, zipCodeId: null, city: null }
                }
            } else if (name === 'city') {
                body = { ...body, zipCodeId: value?.value }
            } else if (name === 'companyId') {
                body = {
                    ...body,
                    divisions: null,
                    fatherZone: null,
                    class: null,
                    userManageId: null,
                }
                getCompanyById(value?.value)
            } else if (name === 'fatherZone') {
                body = {
                    ...body,
                    [name]: value?.value,
                    class: null,
                }

                const inpustFatherZone = fatherList?.map?.((item) => item.value)
                setInputValues((prev) => ({
                    ...prev,
                    class: {
                        ...prev.class,
                        items:
                            childZones
                                .filter((item) => item.father === value?.value && !!inpustFatherZone?.includes(item.value))
                    },
                }))
            } else if (name == 'timeZone' && !value) {
                body = {
                    ...body,
                    [name]: inputValues?.timeZone?.items?.[0].value,
                }
            }

            setData((prev) => ({ ...prev, ...body }))
        }
    }

    const convert = async () => {

        const timeZoneId = inputValues['timeZone'].items?.find(item => item.value == data.timeZone)

        const body = {
            name: data.name,
            email: data.email,
            companyId: data.companyId,
            zipCodeId: data.zipCodeId,
            statusId: data.status,
            phone: data.phone,
            address: data.address,
            latitude: data.latitude,
            longitude: data.longitude,
            score: data.score,
            userManageId: data.userManageId,
            keyCode: data.keyCode,
            timeZone: data.timeZone,
            timeZoneId: timeZoneId?.id,
            zoneId: data.fatherZone,
            divisionId: data.divisions,
            classId: data.class,
            ...(data?.picture?.name && { picture: await sharedAws.uploadAndGetUrl({ file: data.picture, otherBucket: process.env.REACT_APP_BUCKET }) }),
        }

        handleConvert(body)
    }

    useEffect(()=>{
        getCompanyById(value.company?.value)
    },[])


    return (
        <Drawer
            open={open}
            anchor="right"
            PaperProps={{
                sx: { width: '35%', padding: '20px', minWidth: '520px' },
            }}
        >
            <Typography variant="title_grey_big">{t('loogbook.titles.convertToUnivty')}</Typography>

            <DinamicForm input={Object.values(inputValues)} values={data} onChange={crudChange} />

            <Box sx={styles.actions}>
                <LoadingButton disabled={generalDisabled(inputValues, data)} loading={loader} onClick={convert} variant="contained">
                    {t('general.save')}
                </LoadingButton>

                <Box>
                    <Typography variant="body1" sx={styles.cleanFilters} onClick={closeDrawer}>
                        {t('general.cancel')}
                    </Typography>
                </Box>
            </Box>
        </Drawer>

    )
}

